import { Button, Modal, Form, Input, message } from "antd";
import API from "../../../../services/api-request";

const AddDeviceSensor = (props) => {
  const [addForm] = Form.useForm();

  const onFinish = async (values) => {
    const { number } = values;

    const dataForm = {
     number,
    };

    await API.Post("rfid", dataForm)
      .then(() => {
        message.success("RFID has been added");
        props.onGetDeviceSensor();
        addForm.resetFields();
        props.onShowAdd(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(
          `${err?.response?.data?.error}`
        );
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowAdd(false);
    addForm.resetFields();
  };

  return (
    <>
      <Modal
        title="Add RFID"
        open={props.showAdd}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => addForm.submit()}>
            Submit
          </Button>,
        ]}
      >
        <Form
          form={addForm}
          name="Add Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="No. RFID"
            name="number"
            rules={[{ required: true, message: "Please input no. rfid!" }]}
          >
            <Input placeholder="Input No. RFID"/>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddDeviceSensor;
